/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query RouteReadQuery($type: CUSTOMER_TYPE!, $search: String, $take: PositiveInt, $skip: Int) {
  RouteRead(type: $type, search: $search, take: $take, skip: $skip) {
    id,
    displayName,
    type,
    message,
    status
  }
}
`
